import React from "react";

export default function Marquee() {
  const phrase = "Brewed with Passion • Served with Heart • Fresh Coffee • Fresh Moments • ";
  const text = phrase.repeat(4);
  return (
    <section className="bg-[#1A1514] py-8 md:py-10 overflow-hidden border-y border-white/10" data-testid="marquee">
      <div className="marquee-track">
        <span className="font-display italic text-[#F5F2EB] text-4xl md:text-6xl lg:text-7xl whitespace-nowrap pr-8">{text}</span>
        <span className="font-display italic text-[#F5F2EB] text-4xl md:text-6xl lg:text-7xl whitespace-nowrap pr-8" aria-hidden>{text}</span>
      </div>
    </section>
  );
}
